import { INBOUND_SOURCE  } from 'domains/seller-product/constants'
import { SELLER_TYPE  } from 'domains/seller/constants'

// Constant Data that related to Seller Inbound domain

export const MAX_QUANTITY = 35

export const DELIVERY_METHOD = {
  DROPOFF : 'dropoff',
  PICKUP  : 'pickup'
}

export const RECEIVED_STATUS = {
  RECEIVED  : 'received',
  PENDING   : 'pending',
  CANCELLED : 'cancelled'
}

export const CURATION_STATUS = {
  CURATED : 'curated',
  PENDING : 'pending'
}

export const LIVE_PROCESS_STATUS = {
  PENDING    : 'pending',
  READY_LIVE : 'ready_live',
  COMPLETED  : 'completed'
}

export const CONFIRMATION_STATUS = {
  ADMIN_CONFIRMED  : 'admin_confirmed',
  ADMIN_CANCELLED  : 'admin_cancelled',
  SELLER_CONFIRMED : 'seller_confirmed',
  SELLER_CANCELLED : 'seller_cancelled',
  SYSTEM_CANCELLED : 'system_cancelled',
  PENDING          : 'pending'
}

export const GENDER = {
  FEMALE : 'female',
  MALE   : 'male'
}

export const DROPOFF_LOCATION = {
  JAKARTA: {
    label   : 'Jakarta',
    value   : 'jakarta',
    address : 'Jl. Sisingamangaraja No.11-A, RT.2/RW.8, Gunung, Kec. Kby. Baru, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12120'
  },
  PALEMBANG: {
    label   : 'Palembang (Luxury Only)',
    value   : 'palembang',
    address : 'Jl. Slamet Riyadi No.67, 9 Ilir, Kecamatan Ilir Tim. II, Kota Palembang, Sumatera Selatan 30111'
  },
  BANDUNG: {
    label   : 'Bandung (Luxury Only)',
    value   : 'bandung',
    address : 'Paskal Hyper Square 23 Shopping Center. Basement 1. Kebon Jeruk, Andir, Kota Bandung, Jawa Barat 40181'
  },
  SURABAYA: {
    label   : 'Surabaya (Luxury Only)',
    value   : 'surabaya',
    address : 'Pakuwon Trade Center, G/F, D7-12, Puncak Indah Lontar 2, Surabaya, Jawa Timur 60123'
  }
}

/** A Inbound Source constant map by given seller type  */
export const INBOUND_SOURCE_OPTIONS_BY_SELLER_TYPE = {
  [SELLER_TYPE.EXCLUSIVE]: {
    [INBOUND_SOURCE.ES_STORE]: INBOUND_SOURCE.ES_STORE
  },
  [SELLER_TYPE.NORMAL]: {
    [INBOUND_SOURCE.SELLER]: INBOUND_SOURCE.SELLER
  },
  [SELLER_TYPE.DESIGNER]: {
    [INBOUND_SOURCE.SELLER]: INBOUND_SOURCE.SELLER
  },
  [SELLER_TYPE.FEATURED]: {
    [INBOUND_SOURCE.SELLER]: INBOUND_SOURCE.SELLER
  },
  [SELLER_TYPE.SCRAPER]: {
    [INBOUND_SOURCE.SCRAPER]: INBOUND_SOURCE.SCRAPER
  },
  [ SELLER_TYPE.PARTNER ]: {
    [INBOUND_SOURCE.PARTNER]: INBOUND_SOURCE.PARTNER
  }
}

export const AUTO_DISCOUNT_OPTIONS = {
  YA: {
    label : 'Ya',
    value : true
  },
  TIDAK: {
    label : 'Tidak',
    value : false
  }
}
